import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/invoicing/negative-invoices-list')({
  component: () => <Navigate replace search to="/bo/invoicing/negative-invoices" />,
})
